import { Timer } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom-v5-compat';

import { useListEventsQuery } from '../calendar/calendar.api';
import { dateKey } from '../calendar/calendar.lib';
import { activeTimers } from './rounds';

// Live round timers surfaced in the app header. Queries today's events across
// all shops (location omitted), ticks once a second, and renders ONE chip per
// running round — each with the event's logo next to its countdown — all linking
// to the board. The row scrolls horizontally (bounded width) when several rounds
// run at once so it never shoves the rest of the header off-screen. Renders
// nothing when no round is live.
// Polls every 60s so a round Started on another device shows up here too — the
// per-second countdown itself is computed locally and needs no refetch.
// ponytail: 60s poll on every page; drop the interval if the header load matters.
export function RoundTimersIndicator() {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const key = dateKey(now);
    const { data: events } = useListEventsQuery(
        { startDate: key, endDate: `${key} 23:59:59` },
        { pollingInterval: 60_000 },
    );

    const timers = activeTimers(events ?? [], now);
    if (timers.length === 0) return null;

    return (
        <div className="flex max-w-[55vw] items-center gap-1.5 overflow-x-auto">
            {timers.map((t, i) => (
                <Link
                    key={`${t.eventId}-${i}`}
                    to="/v2/current-events"
                    title={`${t.title}${t.location ? ` (${t.location})` : ''} — ${t.display}`}
                    aria-label={`${t.title}: ${t.display} ramase. Vezi evenimentele curente.`}
                    className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-solid border-emerald-300 bg-emerald-50 pl-1 pr-2.5 text-sm font-semibold text-emerald-700 hover:bg-emerald-100 dark:border-emerald-500/40 dark:bg-emerald-900/30 dark:text-emerald-300 dark:hover:bg-emerald-900/50"
                >
                    {t.logoUrl ? (
                        <img
                            src={t.logoUrl}
                            alt=""
                            className="h-6 w-6 shrink-0 rounded-full bg-white object-contain dark:bg-gray-900"
                        />
                    ) : (
                        <Timer aria-hidden="true" className="ml-1 h-4 w-4 shrink-0" />
                    )}
                    <span className="font-mono tabular-nums">{t.display}</span>
                </Link>
            ))}
        </div>
    );
}
